import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Space, Tabs } from 'antd';
import { PlusOutlined, StarFilled, UnorderedListOutlined } from '@ant-design/icons';
import PageLayout from '../../components/layout/PageLayout';
import AllCollectionsList from '../../components/collections/AllCollectionsList';
import FavoriteCollectionsList from '../../components/collections/FavoriteCollectionsList';
import { useUser } from '../../context/UserContext';
import { useCommon } from '../../context/CommonContext';

const CollectionList = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const [activeTab, setActiveTab] = useState('all');
  const { setPageTitle } = useCommon();
  useEffect(() => {
    setPageTitle("Collections");
  }, []);
  const headerActions = (
    <Space wrap>
      <Button 
        type="primary" 
        icon={<PlusOutlined />} 
        onClick={() => navigate('/collections/add/new')}
        size="large"
        style={{ borderRadius: 8 }}
      >
        Add Collection
      </Button>
    </Space>
  );

  const tabItems = [
    {
      key: 'all',
      label: (
        <Space size="middle">
          <UnorderedListOutlined style={{ color: '#1890ff' }} />
          <span style={{ fontWeight: 500 }}>All Collections</span>
        </Space>
      ),
      children: <AllCollectionsList activeTab={activeTab} />,
    },
    {
      key: 'favorites',
      label: (
        <Space size="middle">
          <StarFilled style={{ color: '#faad14' }} />
          <span style={{ fontWeight: 500 }}>My Favorites</span>
        </Space>
      ),
      children: <FavoriteCollectionsList activeTab={activeTab} />,
    },
  ];

  return (
    <PageLayout 
      title="Collections" 
      desc="Manage and organize your content collections" 
      headerContent={headerActions} 
      avatar={user?.avatar}
    >
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabItems}
        size="large"
        style={{ 
          background: '#fff',
          borderRadius: 8,
          padding: '0 0 24px 0'
        }}
        tabBarStyle={{
          padding: '0 24px',
          margin: 0,
          borderBottom: '1px solid #f0f0f0'
        }}
      />
    </PageLayout>
  );
};

export default CollectionList;
